import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const PriorityFlagSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        {...otherProps}
      >
        <path
          d="M9.57065 6.09699C9.6169 6.14387 9.64824 6.20339 9.66069 6.26805C9.67315 6.33272 9.66618 6.39962 9.64065 6.46033C9.61613 6.52154 9.57378 6.57397 9.5191 6.61082C9.46442 6.64768 9.39993 6.66724 9.33398 6.66699H3.00065V11.0003C3.00065 11.0887 2.96553 11.1735 2.90302 11.236C2.84051 11.2985 2.75572 11.3337 2.66732 11.3337C2.57891 11.3337 2.49413 11.2985 2.43162 11.236C2.3691 11.1735 2.33398 11.0887 2.33398 11.0003V1.00033C2.33398 0.91192 2.3691 0.827135 2.43162 0.764623C2.49413 0.702111 2.57891 0.666992 2.66732 0.666992C2.75572 0.666992 2.84051 0.702111 2.90302 0.764623C2.96553 0.827135 3.00065 0.91192 3.00065 1.00033V1.33366H9.33398C9.39993 1.33341 9.46442 1.35298 9.5191 1.38983C9.57378 1.42668 9.61613 1.47911 9.64065 1.54033C9.66618 1.60103 9.67315 1.66793 9.66069 1.7326C9.64824 1.79726 9.6169 1.85678 9.57065 1.90366L7.47065 4.00033L9.57065 6.09699Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default PriorityFlagSVG;
